import React from 'react';
import Draggable from 'react-draggable';
import audioEditorUtils from '../utils/AudioEditorUtils';
import properties from '../../../constants/Properties';
import mouseUtils from '../../utils/MouseUtils';
import storeManager from '../../../store/StoreManager';
import { setVolumePoints } from '../../../actions/AudioEditorActions';
import hoverManager from '../../utils/HoverManager';
import saveManager from '../../utils/SaveManager';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import textSizeUtils from '../../utils/TextSizeUtils';
import locales from '../../../locales/LocalesManager';
import platformDetection from "../../utils/PlatformDetection";

export const ControlPoint = React.createClass({
    onMouseDown(e) {
        saveManager.isContentChanged(true);
        hoverManager.hide();

        if (this.props.controlPointDown)
            this.props.controlPointDown(this.props.index);

        this.setState({
            startX: this.props.x,
            startY: this.props.y,
        });

        audioEditorUtils.isVolumeAction = true;
    },
    onMouseMove(e, coreEvent) {
        hoverManager.hide();

        var point = {};

        if (this.props.index == 0 || this.props.index == this.props.length -1)
            point.x = this.state.startX;
        else
            point.x = this.state.startX + coreEvent.lastX;

        point.y = this.state.startY + coreEvent.lastY;

        if (this.props.controlPointMove)
            this.props.controlPointMove(point);
    },
    onMouseUp(e) {
        saveManager.isContentChanged(true);
        audioEditorUtils.isVolumeAction = false;

        if (this.props.controlPointUp)
            this.props.controlPointUp();
    },
    onKeyDown(e) {
        if (platformDetection.isIOS())
            return;

        if (document.activeElement !=  this.refs.point)
            return;

        const offset = 5;
        var offsetX = 0;
        var offsetY = 0

        switch (e.keyCode) {
            case 37: { // Left
                offsetX = - offset;
                break;
            }
            case 39: { // Right
                offsetX = offset;
                break;
            }
            case 38: { // Top
                offsetY = - offset;
                break;
            }
            case 40: { // Down
                offsetY = offset;
                break;
            }
            case 9: { // Tab --> should send focus to marker
                if (e.shiftKey)
                    return;

                if (this.props.index == this.props.controlPointsLength - 1) {
                    setTimeout(function () {
                        var markerElement = document.getElementById('markerHead');

                        if (markerElement)
                            markerElement.focus();
                    }.bind(this), 10);
                }
                break;
            }
        }

        var point = {};

        if (this.props.index == 0 || this.props.index == this.props.length -1)
            point.x = this.props.x;
        else
            point.x = this.props.x + offsetX;

        point.y = this.props.y + offsetY;

        if (this.props.updateControlPointOnKeyDown)
            this.props.updateControlPointOnKeyDown(point, this.props.index);
    },
    onMouseIn () {
        if (!audioEditorUtils.isVolumeAction) {
            if (audioToolUtils.isLeftSideCollapsed())
                hoverManager.show(this.refs.point, 'audioVolumePoint', 'right');
            else
                hoverManager.show(this.refs.point, 'audioVolumePoint');
        }
    },
    onMouseOut () {
        hoverManager.hide();
    },
    render() {
        var size = audioToolUtils.getGraphControlPointSize();
        var borderSize = properties.VOLUME_CONTROL_LINE_SIZE;
        var holderStyle = {
            position: 'absolute',
            width: size - 2 * borderSize,
            height: size - 2 * borderSize,
            left: this.props.x - size/2,
            top: this.props.y - size/2,
            background: 'white',
            borderRadius: 50,
            borderColor: 'black',
            borderWidth: borderSize,
            borderStyle: 'solid',
            cursor: 'crosshair',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial'
        };

        var ariaLabelValue = locales.getCaption('volumeControlPointElement', 'other') + ' ' + this.props.index;
        var tabIndexValue;

        if (!this.props.isSelected)
            tabIndexValue = '-1';

        return (
            <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                <button ref='point' tabIndex={tabIndexValue} aria-label={ariaLabelValue} style={holderStyle} onKeyDown={this.onKeyDown} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}/>
            </Draggable>
        );
    }
});

export const LineElement = React.createClass({
    setEvents(add = true) {
        if (add) {
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);

            document.addEventListener('touchmove', this.onMouseMove);
            document.addEventListener('touchend', this.onMouseUp);
        } else {
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);

            document.removeEventListener('touchmove', this.onMouseMove);
            document.removeEventListener('touchend', this.onMouseUp);
        }
    },
    onMouseDown(e) {
        saveManager.isContentChanged(true);
        var touchPosition = mouseUtils.getTouchPosition(e);
        var newPoint = {x: touchPosition.x - this.props.globalPoint.x, y: touchPosition.y - this.props.globalPoint.y};

        if (this.props.lineElementDown)
            this.props.lineElementDown(newPoint);

        this.setState({
            startX: newPoint.x,
            startY: newPoint.y,
            initialGlobalX: touchPosition.x,
            initialGlobalY: touchPosition.y
        });

        audioEditorUtils.isVolumeAction = true;
        this.setEvents();
    },
    getCurrentPoint(e) {
        var point = {};
        var touchPosition = mouseUtils.getTouchPosition(e);

        if (this.state && this.state.startX && this.state.initialGlobalX) {
            point.x = this.state.startX + (touchPosition.x - this.state.initialGlobalX);
            point.y = this.state.startY + (touchPosition.y - this.state.initialGlobalY);
        } else {
            point.x = 0;
            point.y = 0;
        }

        return point;
    },
    onMouseMove(e) {
        var point = this.getCurrentPoint(e);

        if (this.props.lineElementMove)
            this.props.lineElementMove(point);
    },
    onMouseUp() {
        if (textSizeUtils.isTextEditMode())
            return;

        saveManager.isContentChanged(true);

        if (this.props.lineElementUp)
            this.props.lineElementUp();

        this.setState({
            startX: undefined,
            startY: undefined,
            initialGlobalX: undefined,
            initialGlobalY: undefined
        });

        this.setEvents(false);
        audioEditorUtils.isVolumeAction = false;
    },
    getLineProperties(x1, y1, x2, y2) {
        var distance = Math.sqrt((x1-x2)*(x1-x2) + (y1-y2)*(y1-y2));
        var centerX = (x1+x2)/2;
        var centerY = (y1+y2)/2;

        var angle = Math.atan2(y1-y2, x1-x2);
        var angleDegrees = (angle * 180) / Math.PI;

        var properties = {};

        properties.width = distance;
        properties.top = centerY;
        properties.left = centerX - distance / 2;
        properties.transform = 'rotate(' + angleDegrees + 'deg)';

        return properties;
    },
    render() {
        var holderHeight = audioToolUtils.getGraphControlLineSize();
        var lineSize = properties.LINE_SIZE;
        var offset = holderHeight / 2;

        var lineProperties = this.getLineProperties(this.props.x1, this.props.y1 - offset, this.props.x2, this.props.y2 - offset);
        var holderStyle = {
            position: 'absolute',
            width: lineProperties.width,
            height: holderHeight,
            top: lineProperties.top,
            left: lineProperties.left,
            transform: lineProperties.transform,
            cursor: 'crosshair',
            display: 'block'
        };

        var lineStyle = {
            position: 'absolute',
            width: holderStyle.width,
            height: lineSize,
            top: holderStyle.height / 2 - lineSize / 2,
            left: 0,
            background: 'black',
            display: 'block'
        };

        return (
            <span style={holderStyle} onMouseDown={this.onMouseDown} onTouchStart={this.onMouseDown}>
                <span style={lineStyle}/>
            </span>
        );
    }
});

export const AudioGraph = React.createClass({
    getInitialState() {
        return {
            currentPoint: undefined,
            controlPoints: undefined
        };
    },
    getInnerZoom(time) {
        var zoom = audioEditorUtils.getZoomValue();
        var itemWidth = audioEditorUtils.getSlideWidth(time);
        var innerWidth = itemWidth - audioToolUtils.getGraphControlPointSize();

        return (innerWidth * zoom) / itemWidth;
    },
    getCorrectedControlPoints() {
        if (this.props.audio.points) {
            var points = [];
            var i;
            var point;
            var duration = this.props.audio.duration;

            for (i = 0; i < this.props.audio.points.length; i++) {
                point = this.props.audio.points[i];

                if (point.time < 0 || point.time > duration) {
                    // something wrong
                    if (point.time > duration && (point.time - duration) < 0.001) {
                        point.time = duration;
                        points.push(point);
                    }
                } else {
                    points.push(point);
                }
            }

            return points;
        } else
            return undefined;
    },
    getControlPointsFromProps() {
        var controlPoints = this.getCorrectedControlPoints();
        var newPoints = [];
        var i;
        var innerZoom = this.getInnerZoom(this.props.audio.duration);
        var topOffset = properties.LINE_SIZE + audioToolUtils.getGraphControlPointSize() / 2;
        var leftOffset = audioToolUtils.getGraphControlPointSize() / 2;

        if (controlPoints == undefined || controlPoints.length < 2) {
            newPoints = [];

            newPoints.push({x: leftOffset, y: topOffset});
            newPoints.push({x: audioEditorUtils.getSlideWidth(this.props.audio.duration, innerZoom) + leftOffset, y: topOffset});

            return newPoints;
        }

        for (i=0; i<controlPoints.length; i++) {
            var x = audioEditorUtils.getSlideWidth(controlPoints[i].time, innerZoom) + leftOffset;
            var y = this.getHeight() * (1 - controlPoints[i].vol) + topOffset;

            newPoints.push({x, y});
        }

        return this.sortElements(newPoints);
    },
    updateControlPointsToState(controlPoints, currentPoint) {
        var points = [].concat(controlPoints);
        points.push(currentPoint);
        points = this.sortElements(points);

        var newPoints = [];
        var i;
        var dispatch = this.getDispatch();
        var topOffset = properties.LINE_SIZE + audioToolUtils.getGraphControlPointSize() / 2;
        var leftOffset = audioToolUtils.getGraphControlPointSize() / 2;
        var innerZoom = this.getInnerZoom(this.props.audio.duration);
        var y;
        var x;

        for (i=0; i<points.length; i++) {
            if (points[i]) {
                x = points[i].x - leftOffset;
                var time = x / (innerZoom * properties.SLIDE_ITEM_WIDTH);

                y = points[i].y - topOffset;
                var volume = 1 - y / this.getHeight();

                newPoints.push({time: time, vol: volume});
            }
        }

        dispatch(setVolumePoints(this.props.audio.uuid, newPoints));
        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();

        this.setState({
            controlPoints: undefined,
            currentPoint: undefined
        });
    },
    sortElements(array) {
        array.sort(function(a, b){return a.x - b.x});

        return array;
    },
    getHeight() {
      return audioToolUtils.timelineHeight() - properties.LINE_SIZE - audioToolUtils.getGraphControlPointSize();
    },
    checkControlPoint(point) {
        const topLimit = properties.LINE_SIZE + audioToolUtils.getGraphControlPointSize() / 2;
        const bottomLimit = this.getHeight() + topLimit;
        const leftLimit = audioToolUtils.getGraphControlPointSize() / 2;
        const rightLimit = audioEditorUtils.getSlideWidth(this.props.audio.duration) - leftLimit;

        if (point.y < topLimit)
            point.y = topLimit;

        if ( point.y > bottomLimit)
            point.y = bottomLimit;

        if ( point.x < leftLimit)
            point.x = leftLimit;

        if (point.x > rightLimit)
            point.x = rightLimit;
    },
    getDispatch() {
        const store = storeManager.getStore();
        return store.dispatch;
    },
    getControlPoints() {
        if (this.state.controlPoints) {
            var points = [].concat(this.state.controlPoints);
            points.push(this.state.currentPoint);

            return this.sortElements(points);
        } else {
            return this.getControlPointsFromProps();
        }
    },
    controlPointDown(index) {
        saveManager.isContentChanged(true);

        var controlPointsArray = this.getControlPointsFromProps();
        var currentPoint = controlPointsArray[index];
        controlPointsArray.splice(index, 1);

        this.setState({
            currentPoint,
            controlPoints: controlPointsArray
        });
    },
    controlPointMove(currentPoint) {
        this.checkControlPoint(currentPoint);

        this.setState({
            currentPoint
        });
    },
    controlPointUp() {
        saveManager.isContentChanged(true);

        setTimeout(function(controlPoints, currentPoint) {
                this.updateControlPointsToState(controlPoints, currentPoint);
        }.bind(this), 1, this.state.controlPoints, this.state.currentPoint);
    },
    updateControlPointOnKeyDown(currentPointElement, index) {
        saveManager.isContentChanged(true);

        var controlPointsArray = this.getControlPointsFromProps();
        controlPointsArray.splice(index, 1);

        this.checkControlPoint(currentPointElement);

        setTimeout(function(controlPoints, currentPoint) {
            this.updateControlPointsToState(controlPoints, currentPoint);
        }.bind(this), 1, controlPointsArray, currentPointElement);
    },
    lineElementDown(point) {
        var controlPointsArray = this.getControlPointsFromProps();
        this.checkControlPoint(point);

        this.setState({
            currentPoint: point,
            controlPoints: controlPointsArray
        });
    },
    addControlPointHandler() {
        var parentElement = document.getElementById(this.props.parentId);
        var plusElement = document.getElementById('addVolumeControlPoint');

        if (!parentElement || !plusElement)
            return;

        var parentPosition = parentElement.getBoundingClientRect();
        var plusPosition = plusElement.getBoundingClientRect();
        var plusSize = 18;
        var controlPointSize = 14;
        var point = {x: (plusPosition.left + plusSize / 2) - parentPosition.left, y: controlPointSize / 2};
        var controlPoints = this.getControlPointsFromProps();

        this.checkControlPoint(point);
        this.updateControlPointsToState(controlPoints, point);

        this.forceUpdate();
    },
    render() {
        var controlPoints = this.getControlPoints();

        if (controlPoints.length < 2 || audioEditorUtils.isControlPointAction)
            return (<div/>);

        if (this.props.isSelected)
            audioEditorUtils.addControlPointHandler = this.addControlPointHandler;

        var holderStyle = {
            position: 'absolute',
            display: 'block',
            top: 0
        };

        var i;
        var lines = [];
        var points = [];

        for (i=0; i<controlPoints.length; i++) {
            if (controlPoints[i])
                points.push(<ControlPoint key={'point_' + i} length={controlPoints.length} x={controlPoints[i].x} y={controlPoints[i].y} index={i} isSelected={this.props.isSelected} controlPointsLength={controlPoints.length} controlPointDown={this.controlPointDown} controlPointMove={this.controlPointMove} controlPointUp={this.controlPointUp} updateControlPointOnKeyDown={this.updateControlPointOnKeyDown}/>);
        }

        for (i=1; i<controlPoints.length; i++) {
            if (controlPoints[i-1] && controlPoints[i])
                lines.push(<LineElement key={'line' + i} x1={controlPoints[i-1].x} y1={controlPoints[i-1].y} x2={controlPoints[i].x} y2={controlPoints[i].y} globalPoint={this.props.globalPoint} lineElementDown={this.lineElementDown} lineElementMove={this.controlPointMove} lineElementUp={this.controlPointUp}/>);
        }

        return (
            <span style={holderStyle}>
                {lines}
                {points}
            </span>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/AudioGraph.js
 **/